import * as FormComponents from './create/webserviceForms';

/**
 * Explicit mapping of form component names to their implementations
 */
export const FORM_COMPONENTS_MAP = {
    DigitickForm: FormComponents.DigitickForm,
    FeverForm: FormComponents.FeverForm,
    FnacForm: FormComponents.FnacForm,
    UniverseForm: FormComponents.UniverseForm,
    LenndForm: FormComponents.LenndForm,
    TicketnetForm: FormComponents.TicketnetForm,
    PlaypassForm: FormComponents.PlaypassForm,
    SecutixForm: FormComponents.SecutixForm,
    SeeticketsDEForm: FormComponents.SeeticketsDEForm,
    SeeticketESForm: FormComponents.SeeticketESForm,
    RegiondoForm: FormComponents.RegiondoForm,
    VivenuForm: FormComponents.VivenuForm,
    TicketmasterSportForm: FormComponents.TicketmasterSportForm
};

/**
 * Configuration of webservices supported by Weezevent
 * Centralized structure to maintain distributor information
 */
export const WEBSERVICE_CONFIG = {
    digitick: {
        text: 'Digitick',
        fields: ['login', 'password', 'wsdl'],
        formComponent: 'DigitickForm'
    },
    fever: {
        text: 'Fever',
        fields: ['api_key'],
        formComponent: 'FeverForm'
    },
    fnac: {
        text: 'Fnac',
        fields: ['login', 'password'],
        formComponent: 'FnacForm'
    },
    universe: {
        text: 'Universe',
        fields: ['authCode'],
        formComponent: 'UniverseForm'
    },
    lennd: {
        text: 'Lennd',
        fields: ['accessToken'],
        formComponent: 'LenndForm'
    },
    ticketnet: {
        text: 'Ticketnet',
        fields: ['login', 'password', 'account_type'],
        formComponent: 'TicketnetForm'
    },
    playpass: {
        text: 'Playpass',
        fields: ['login', 'password', 'tenant', 'getin_url'],
        formComponent: 'PlaypassForm'
    },
    secutix: {
        text: 'Secutix',
        fields: ['login', 'password', 'url'],
        formComponent: 'SecutixForm'
    },
    seetickets_de: {
        text: 'Seetickets DE',
        fields: ['merchant_id', 'refresh_token'],
        formComponent: 'SeeticketsDEForm'
    },
    seetickets_es: {
        text: 'Seetickets ES',
        fields: ['promoter_id', 'promoter_name'],
        formComponent: 'SeeticketESForm'
    },
    regiondo: {
        text: 'Regiondo',
        fields: ['public_key', 'private_key'],
        formComponent: 'RegiondoForm'
    },
    vivenu: {
        text: 'Vivenu',
        fields: ['access_token'],
        formComponent: 'VivenuForm'
    },
    ticketmastersport: {
        text: 'Ticketmaster sport club',
        fields: ['api_key'],
        formComponent: 'TicketmasterSportForm'
    }
};

/**
 * Special configuration for 'hook' type which is handled differently from other webservices
 * Used for custom imports with specific provider options
 */
export const HOOK_CONFIG = {
    text: 'Custom Import',
    fields: ['name', 'end_date', 'default_provider', 'create_form_by'],
    required: {
        name: true,
        end_date: false,
        default_provider: false,
        create_form_by: true
    },
    // Provider options available for hook custom imports
    hookProviderOptions: [
        { text: 'Default', value: 'default' },
        { text: 'Seetickets', value: 'seetickets' },
        { text: 'Ticketmaster', value: 'ticketmaster' },
        { text: 'Eventim', value: 'eventim' },
        { text: 'Eventbrite', value: 'eventbrite' },
        { text: 'Paylogic', value: 'paylogic' },
        { text: 'DT Consulting', value: 'DTC' }
    ]
};

/**
 * Options for creating forms based on the selected type
 * Used in the form to allow users to choose how they want to create the form
 */
export const CREATE_FORM_BY_OPTIONS = [
    { value: 'rate', textKey: 'ticket.webservice.form.createFormBy.rate' },
    { value: 'subscription_link', textKey: 'ticket.webservice.form.createFormBy.management_rule' },
    { value: 'event', textKey: 'ticket.webservice.form.createFormBy.event' }
];
